module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14120e6444ca2744dad272d8ca2a4646.svg";